import React from 'react';
import { Alert, Button } from 'antd';
import moment from 'moment';
import { DATE_FORMAT } from '@app/constants/dateFormats';
import { formatMoney } from '@app/utils/utils';

interface Props {
  /** Số dư điểm của khách. */
  points?: number | null;
  /** Phần đang giữ ở đơn chưa hoàn tất, chưa dùng được cho đơn khác. */
  reserved?: number | null;
  /** Giá trị 1 điểm (₫); 0 = chưa cấu hình đổi điểm. */
  pointValue?: number | null;
  /** Điểm đang được trừ trên bill. */
  applied?: boolean;
  /** Có = đang ở form đơn, hiện nút áp dụng vào bill. */
  onApply?: () => void;
  className?: string;
}

/** Cảnh báo khách còn điểm chưa dùng, để nhân viên không bỏ sót khi lỡ bấm Huỷ ở hộp thoại hỏi điểm. */
const CustomerPointsAlert: React.FC<Props> = ({ points, reserved, pointValue, applied, onApply, className }) => {
  const balance = Number(points) || 0;
  const held = Number(reserved) || 0;
  const usable = Math.max(balance - held, 0);
  const value = Number(pointValue) || 0;
  if (balance <= 0 || value <= 0) return null;

  // Điểm chỉ dùng trong năm: sang năm mới phần chưa dùng bị reset (Points::ExpireJob).
  const expiry = moment().endOf('year').format(DATE_FORMAT);
  const usableText = `${usable} điểm tích luỹ (= ${formatMoney(Math.round(usable * value))}, hạn dùng đến ${expiry})`;
  const summary = held > 0 ? `Khách có ${balance} điểm, ${held} điểm đang giữ ở đơn chưa hoàn tất, còn dùng được ${usableText}` : `Khách có ${usableText}`;

  if (applied) {
    return <Alert className={className} type="success" showIcon message={`${summary} — đang trừ trên bill`} />;
  }

  return (
    <Alert
      className={className}
      type="warning"
      showIcon
      message={onApply && usable > 0 ? `${summary}, chưa áp dụng` : summary}
      action={
        onApply &&
        usable > 0 && (
          <Button size="small" type="primary" onClick={onApply}>
            Áp dụng
          </Button>
        )
      }
    />
  );
};

export default CustomerPointsAlert;
